<!-- START CONTENT -->
<section id="main-content" class="sidebar_shift">
  <section class="wrapper main-wrapper row">
    <!--<form class="form-horizontal" [formGroup]="newRequestForm" (ngSubmit)="submitRequest(newRequestForm.value)" autocomplete="off">-->
    <form [formGroup]="newRequestForm" (ngSubmit)="submitRequest(newRequestForm.value)" autocomplete="off">
      <div class="row">

        <div class="col-lg-6">
          <section class="box ">
            <header class="panel_header">
              <h2 class="title pull-left">Patient details</h2>
              <div class="actions panel_actions pull-right">
                <a class="box_toggle fa fa-chevron-down"></a>
                <a class="box_setting fa fa-cog" data-toggle="modal" href="form-elements.html#section-settings"></a>
              </div>
            </header>
            <div class="content-body">

              <div class="row">
                <div class="form-group col-md-6">
                  @if(UserSource.Site !== 'TRIALS') {
                    <label class="form-label" for="hospitalNo">Hospital No. / Patient Number</label>
                  }
                  @if(UserSource.Site == 'TRIALS') {
                    <label class="form-label" for="hospitalNo">Volunteer Number</label>
                  }
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="hospitalNo" name="hospitalNo" id="hospitalNo" />
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="form-label" for="reference">Reference</label>
                  <div class=.controls>
                    <input type="text" class="form-control" formControlName="reference" name="reference" id="reference" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6">
                  @if(UserSource.Site !== 'TRIALS') {
                  <label class="form-label" for="forename">Forename</label>
                  }
                  @if(UserSource.Site == 'TRIALS') {
                    <label class="form-label" for="forename">Subject ID</label>
                  }
                    <div class="controls">
                      <input type="text" class="form-control" formControlName="forename" name="forename" id="forename" [placeholder]="newRequestForm.value.forename.invalid ? '*** Required ***' : ''" />
                      @if(newRequestForm.value.forename.invalid && newRequestForm.value.forename.touched){
                      <em class="text-danger">Required</em>
                      }
                    </div>
                </div>
                <div class="form-group col-md-6">
                  @if(UserSource.Site !== 'TRIALS') {
                    <label class="form-label" for="surname">Surname</label>
                  }
                  @if(UserSource.Site  == 'TRIALS') {
                    <label class="form-label" for="surname">Subject No.</label>
                  }
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="surname" name="surname" id="surname" [placeholder]="newRequestForm.value.surname.invalid ? '*** Required ***' : ''" />
                    @if(newRequestForm.value.surname.invalid&&newRequestForm.value.surname.touched) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-4">
                  <label class="form-label" for="title">Title</label>
                  <div class="controls">
                    @if(otherTitle) {
                      <input type="text" class="form-control" formControlName="title" name="title" />
                    }
                    @if(!otherTitle) {
                      <select formControlName="title" name="title" id="title" class="form-control input-md m-bot15" (change)="onTitleSelectionChange($event)">
                        <option value="MR">Mr</option>
                        <option value="MRS">Mrs</option>
                        <option value="MISS">Miss</option>
                        <option value="MASTER">Master</option>
                        <option value="OTHER">Other</option>
                      </select>
                    }
                  </div>
                </div>


                <div class="form-group col-md-4">
                  <label class="form-label" for="sex">Sex</label>
                  <div class="controls">
                    <select formControlName="sex" name="sex" id="sex" class="form-control input-md m-bot15" (change)="onSexSelectionChange($event)">
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="U">Unknown</option>
                    </select>
                    @if(newRequestForm.value.sex.invalid) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>


                <div class="form-group col-md-4">
                  <label class="form-label" for="dob">
                    DOB
                  </label>
                  <div class="controls">

                    <input type="date" class="form-control" formControlName="dob" name="dob" [placeholder]="newRequestForm.value.dob.invalid ? '*** Required ***' : ''" />
                    @if(newRequestForm.value.dob.invalid) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-4">
                  <label class="form-label" for="address1">Address 1</label>
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="address1" name="address1" [placeholder]="newRequestForm.value.address1.invalid ? '*** Required ***' : ''" />
                    @if(newRequestForm.value.address1.invalid && newRequestForm.value.address1.touched) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>

                <div class="form-group col-md-4">
                  <label class="form-label" for="address2">Address 2</label>
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="address2" name="address2" [placeholder]="newRequestForm.value.address2.invalid ? '*** Required ***' : ''" />
                    @if(newRequestForm.value.address2.invalid && newRequestForm.value.address2.touched) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>

                <div class="form-group col-md-4">
                  <label class="form-label" for="address3">Address 3</label>
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="address3" name="address3" [placeholder]="newRequestForm.value.address3.invalid ? '*** Required ***' : ''" />
                    @if(newRequestForm.value.address3.invalid && newRequestForm.value.address3.touched) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-4">
                  <label class="form-label" for="postCode">PostCode</label>
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="postCode" name="postCode" [placeholder]="newRequestForm.value.postCode.invalid ? '*** Required ***' : ''" />
                    @if(newRequestForm.value.postCode.invalid && newRequestForm.value.postCode.touched) {
                    <em class="text-danger">Required</em>
                    }
                  </div>
                </div>
                @if(UserSource.Site !== 'CROM'){
                  <div class="form-group col-md-4">
                    <label class="form-label" for="email">Email</label>
                    <div class="controls">
                      <input type="text" class="form-control" formControlName="email" name="email" />
                    </div>
                  </div>
                }
                @if(UserSource.Site !== 'CROM') {
                  <div class="form-group col-md-4">
                    <label class="form-label" for="phone">Phone</label>
                    <div class="controls">
                      <input type="text" class="form-control" formControlName="phone" name="phone" />
                    </div>
                  </div>
                }
              </div>

              <div class="form-group">
                <label class="form-label" for="clinDets">Clinical details</label>
                <div class="controls">
                  <input type="text" class="form-control" formControlName="clinDets" name="clinDets" />
                </div>
              </div>

            </div>
          </section>
        </div>

        <div class="col-lg-6">

          <section class="box ">
            <header class="panel_header">
              <h2 class="title pull-left">Request details</h2>
              <div class="actions panel_actions pull-right">
                <a class="box_toggle fa fa-chevron-down"></a>
                <a class="box_setting fa fa-cog" data-toggle="modal" href="form-elements.html#section-settings"></a>
              </div>
            </header>
            <div class="content-body">

              <div class="row">
                <div class="form-group col-md-6">
                  @if(UserSource.Site !== 'TRIALS'){
                  <label class="form-label" for="attendingDr">Attending doctor</label>
                  }
                  @if(UserSource.Site  == 'TRIALS') {
                  <label class="form-label" for="attendingDr">Visit/Timepoint</label>
                  }
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="attendingDr" name="attendingDr" id="attendingDr" />
                  </div>
                </div>
                @if(UserSource.Site !== 'CROM') {
                <div class="form-group col-md-6">
                  <label class="form-label" for="accountTo">Account to</label>
                  <div class="controls">
                    <select formControlName="accountTo" name="accountTo" id="accountTo" class="form-control input-md m-bot15">
                      <option selected value="D">Doctor</option>
                      <option value="P">Patient</option>
                    </select>
                  </div>
                  @if(newRequestForm.value.accountTo.invalid && newRequestForm.value.accountTo.touched) {
                  <em class="text-danger">Required</em>
                  }
                </div>
                }
              </div>
              @if(UserSource.Site !== 'CROM'){
              <div class="row">
                <div class="form-group col-md-6">
                  <label class="form-label" for="insuranceNum">Insurance Number</label>
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="insuranceNum" name="insuranceNum" id="insuranceNum" />
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="form-label" for="insuranceCo">Insurance Company</label>
                  <div class="controls">
                    <input type="text" class="form-control" formControlName="insuranceCo" name="insuranceCo" id="insuranceCo" />
                  </div>
                </div>
              </div>
              }
              <div class="row">
                <div class="form-group col-md-6">
                  <label class="form-label">Sample date</label>
                  <div class="controls">
                    <input type="date" class="form-control" formControlName="sampleDate" name="sampleDate" />
                    @if(newRequestForm.value.sampleDate.invalid && newRequestForm.value.sampleDate.touched) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="form-label">Sample time</label>
                  <div class="controls">
                    <input type="time" class="form-control timepicker" formControlName="sampleTime" name="sampleTime" placeholder="HH:MM" step="60" min="00:00" max="23:59" />
                    @if(newRequestForm.value.sampleTime.invalid && newRequestForm.value.sampleTime.touched) {
                      <em class="text-danger">Required</em>
                    }
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <header class="panel_header">
                    <h2 class="title pull-left">&nbsp;</h2>
                  </header>
                </div>
              </div>
              <div class="row">
                @if(UserSource.Site !== 'CROM') {
                <div class="form-group col-md-6">
                  <div class="controls">
                    <input tabindex="5" type="checkbox" formControlName="isGrey" name="isGrey" id="isGrey" class="icheckbox_square-blue" unchecked>
                    <label class="icheck-label form-label" for="isGrey">Have you sent a grey tube?</label>
                  </div>
                </div>
                }
                <div class="form-group col-md-6">
                  <div class="controls">
                    <input tabindex="5" type="checkbox" formControlName="isFasting" name="isFasting" id="isFasting" class="icheckbox_square-blue" unchecked>
                    <label class="icheck-label form-label" for="isFasting">Is the Patient Fasting?</label>
                  </div>
                </div>
              </div>
              @if(user.CanOrderKits == true) {
                <div class="row">
                  <div class="col-md-12">
                    <header class="panel_header">
                      <h2 class="title pull-left">Kit ordering - sent directly to patient</h2>
                    </header>
                  </div>
                </div>
              }
                <div class="row">
                  @if(user.CanOrderKits == true) {
                  <div class="form-group col-md-6">
                    <div class="controls">
                      <input tabindex="5" type="checkbox" formControlName="needsKit" name="needsKit" [attr.disabled]="newRequestForm.value.needsVenous.value ? true : null" id="needsKit" class="icheckbox_square-blue" (change)="openDialog($event)" unchecked>
                      <label class="icheck-label form-label" for="needsKit">self collect collection kit</label>
                    </div>
                  </div>
                  }
                  @if(user.CanOrderKits == true) {
                    <div class="form-group col-md-6">
                      <div class="controls">
                        <input tabindex="5" type="checkbox" formControlName="needsVenous" name="needsVenous" [attr.disabled]="newRequestForm.value.needsKit.value ? true : null" id="needsVenous" class="icheckbox_square-blue" (change)="openDialog($event)" unchecked>
                        <label class="icheck-label form-label" for="needsVenous">VENOUS blood kit</label>
                      </div>
                    </div>
                  }
                </div>
              <div class="row">
                <div class="form-group">
                  <div class="control no-left-padding">
                    <input type="submit" value="Save" class="btn btn-success form-control" [disabled]="isFormInValid()" />
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <section class="box ">
            <header class="panel_header">
              <h2 class="title pull-left">Tests</h2>
              <div class="actions panel_actions pull-right">
                <a class="box_toggle fa fa-chevron-down"></a>
                <a class="box_setting fa fa-cog" data-toggle="modal" href="form-components-multiselect.html#section-settings"></a>
              </div>
            </header>
            <div class="form-group">
              <h4 class="title pull-left">Top 10 tests:</h4>
              <div>
                @for(topTest of Top10Tests; track topTest.Id) {
                  <input type="button" class="test-btn btn-success" [ngModelOptions]="{standalone: true}" [(ngModel)]="topTest.Description" [disabled]="isSelected(topTest)" (click)="selectTest($event, topTest)" />
                }
              </div>
            </div>
            <fieldset>
              <label class="form-label">Ordered tests:</label>
              <div class="col-lg-12 no-left-padding">
                <div>
                  @for(test of SelectedTests; track test.Id) {
                  <input type="button" class="test-btn btn-primary" [ngModelOptions]="{standalone: true}" [(ngModel)]="test.TestCode" (click)="removeTest(test)">
                  }
                </div>
              </div>
              <div class="form-group">
                <input type="text" [formControl]="testControl" class="form-control" placeholder="search" name="testControl" (keydown)="onKey($event)" />
                @if(showTestDropDown) {
                <div class="autocomplete-dropdown">
                  @for(test of Tests; track test.Id) {
                    <div class="testRow" (click)="selectTest($event, test)">
                      {{ test.TestCode }} - {{ test.Description }}
                    </div>
                  }
                </div>
                }
              </div>
              <!--p class="form-group bg-warning text-danger" *ngIf="!TestsArevalid()">You should select at least one test and up to 10 tests </p-->
              @if(!TestsArevalid()) {
                <p class="form-group bg-warning text-danger">{{Message}}</p>
              }
            </fieldset>

          </section>
        </div>
      </div>
    </form>
  </section>
</section>

